/**
 * Centralized legal/branding configuration for InkPhD.
 *
 * EDIT THIS FILE when:
 *  - You register a legal entity / data controller
 *  - You acquire a domain
 *  - You appoint a DPO
 *  - You change contact email
 *
 * All Legal pages (Terms, Privacy, RUO, AI Transparency) read from here.
 */
export const LEGAL_CONFIG = {
  product: {
    name: 'InkPhD',
    tagline_bg: 'Evidence-grounded doctoral writing for medical research',
    tagline_en: 'Evidence-grounded doctoral writing for medical research',
    positioning_bg: 'Научна инфраструктура за академично писане — със семантично извличане на литература, проверка на DOI/PMID цитати и EQUATOR-съвместими научни workflow-и.',
    positioning_en: 'Scientific writing infrastructure for researchers — with semantic literature retrieval, DOI/PMID citation verification, and EQUATOR-compliant scholarly workflows.',
  },

  // Legal entity / data controller
  controller: {
    legal_name: 'International Sci Ink Press Ltd',
    legal_name_bg: 'Интернешънъл Сци Инк Прес ЕООД',
    legal_form: 'ЕООД (single-member limited liability company)',
    registration_number: '205414288',
    vat_number: 'BG205414288',
    address: '57 Antim I Str., floor 1, Vazrazhdane district, Sofia 1303',
    address_bg: 'гр. София 1303, р-н Възраждане, ул. „Антим I" 57, ет. 1',
    representative: 'Ivan Kalinov Inkov, Manager',
    country: 'Bulgaria',
    contact_email: 'contact@inkphd.com',
    dpo_email: 'dpo@inkphd.com',
    data_requests_email: 'data-requests@inkphd.com',
  },

  domain: {
    primary: 'inkphd.com',
  },

  versions: {
    terms_version: '2026.01.0',
    terms_effective_date: '2026-01-01',
    privacy_version: '2026.01.0',
    privacy_effective_date: '2026-01-01',
  },

  jurisdictions: {
    primary: 'European Union (GDPR)',
    secondary: ['United States (state laws including CCPA)', 'United Kingdom (UK GDPR)'],
  },

  // Default exported AI-assistance disclosure (used in chapter exports)
  exportDisclosure: {
    bg: 'Настоящият ръкопис е разработен с AI-асистирана литературна синтеза и чернови чрез InkPhD. Всички твърдения трябва да бъдат проверени независимо от квалифицирани изследователи преди публикуване или клинично прилагане.',
    en: 'This manuscript was developed with AI-assisted retrieval, drafting, and literature synthesis support via InkPhD. All claims must be independently verified by qualified researchers before publication or clinical use.',
  },

  watermark: {
    bg: 'AI-асистирана чернова — изисква проверка от автор преди публикуване.',
    en: 'AI-assisted draft — requires author verification before publication.',
  },
};

export default LEGAL_CONFIG;
